'use client';

import React from 'react';

import SearchBar from '@/components/design/searchBar';
import SearchResult from '@/components/design/searchResult';
import useContentBank from '@/hooks/queries/useContentBank';
import routes from '@/statics/routes';

type ContentBankSearchBarProps = {
  categoryId?: string;
};

export default function ContentBankSearchBar({
  categoryId,
}: ContentBankSearchBarProps): React.ReactElement {
  const useContentBankSearch = (query: string) => {
    const { data, isFetched, isFetching } = useContentBank({
      queries: { category_id: categoryId, search: query },
      enabled: Boolean(query),
    });
    return {
      results: data?.pages[0].list || [],
      isFetched,
      isFetching,
    };
  };

  return (
    <SearchBar
      useSearch={useContentBankSearch}
      renderResult={(item) => (
        <SearchResult
          key={item.id}
          title={item.title || ''}
          description={item.description || ''}
          image={item.preview_image}
          href={routes.content.href(item.id)}
        />
      )}
    />
  );
}
